import * as React from "react";
import {
    Card,
    Typography,
    Grid,
    Box,
} from "@mui/material";
import AcUnitTwoToneIcon from "@mui/icons-material/AcUnitTwoTone";
import NearbyErrorIcon from "@mui/icons-material/NearbyError";
import WarningIcon from "@mui/icons-material/Warning";
import InsightsIcon from "@mui/icons-material/Insights";
import TaskIcon from "@mui/icons-material/Task";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import CycloneIcon from '@mui/icons-material/Cyclone';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import GestureIcon from '@mui/icons-material/Gesture';
import HeatPumpIcon from '@mui/icons-material/HeatPump';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import AirIcon from '@mui/icons-material/Air';
import HubIcon from '@mui/icons-material/Hub';
import { useState } from "react";
import { useEffect } from "react";

export const AlgorithmCard = (props) => {

    const [percentage, setPercentage] = useState(false)
    useEffect(() => {
        setPercentage(props.percentage)
    }, [])
    const cardstyles = {
        boxShadow: "none",
        borderRadius: "18px",
        width: 215,
        display: "flex",
        alignItems: "center",
        p: 2,
    };
    const circleBackStyle = {
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        width: 55,
        height: 55,
        borderRadius: "50%",
        backgroundColor: "#f5f5f5",
    };

    const TypographyStyle = {
        marginLeft: "0.8rem",
        marginTop: "0.3rem",
        display: "flex",
        flexDirection: "column",

    };

    const fonstStyle = {
        fontWeight: "bold",
        fontFamily: "DM Sans, sans-serif",
        fontSize: "14px",
    }

    const calculatePercentage = (realValue, totalvalue) => {
        if (totalvalue === 0 || realValue === 0) return 0;
        return parseFloat((realValue / totalvalue) * 100).toFixed(1);
    };

    const getPercentage = () => {

        if (percentage) {
            const cal = calculatePercentage(props.value, props.totalValue);
            return "(" + cal + " % )";
        }
        return "";
    }

    const getIcon = (algorithm) => {
        switch (algorithm) {
            case "Total Units":
                return (
                    <AcUnitTwoToneIcon sx={{ fontSize: 35, color: "#0B6BCB" }} />
                )
            case "Raw Data Cleaned":
                return (
                    <TaskIcon sx={{ fontSize: 35, color: "#1daa07" }} />
                )
            case "L1 Calculation":
                return (
                    <CycloneIcon sx={{ fontSize: 35, color: "#6332e1" }} />
                )
            case "Leakage Detection":
                return (
                    <InsightsIcon sx={{ fontSize: 35, color: "#ff9708" }} />
                )
            case "Cond Foul All Bins":
                return (
                    <Diversity2Icon sx={{ fontSize: 35, color: "#240f72" }} />
                )
            case "Cond Fouling":
                return (
                    <AirIcon sx={{ fontSize: 35, color: "#6907ff" }} />
                )
            case "Cond Foul Trend":
                return (
                    <GestureIcon sx={{ fontSize: 35, color: "#561299" }} />
                )
            case "Evap Fouling":
                return (
                    <HeatPumpIcon sx={{ fontSize: 35, color: "#125f91" }} />
                )
            case "Thr Aanalysis":
                return (
                    <QueryStatsIcon sx={{ fontSize: 35, color: "#6fd643" }} />
                )
            case "Last Updated":
                return (
                    <EventRepeatIcon sx={{ fontSize: 35, color: "#0096a0" }} />
                )
        }

    }

    return (
        <>

            <Grid item>
                <Card sx={cardstyles}>
                    <Box sx={circleBackStyle}>
                        {getIcon(props.name)}
                    </Box>
                    <Box sx={TypographyStyle}>
                        <Typography
                            sx={{
                                color: "#6c6c6c",
                                fontSize: "13px",
                                marginBottom: "0.3rem",
                                fontFamily: "DM Sans, sans-serif"
                            }}
                        >
                            {props.name}
                        </Typography>

                        <Typography sx={fonstStyle}>{props.value} {getPercentage()}</Typography>

                    </Box>
                </Card>
            </Grid>

        </>
    )
}